import MESSAGES from 'constants/messages';
import {
  stringIsInvalid,
  stringMaxLengthIsInvalid,
} from 'store/utils/validators';
import termOptions from 'constants/termOptions';

export default (ruleGroupName = '', props) => {
  let errors;

  if (!ruleGroupName || stringIsInvalid(ruleGroupName)) {
    errors = `${
      termOptions[props.modelName].modal.name
    } names must start with a letter and consist only of letters, digits, or underscores`;
  }

  if (stringMaxLengthIsInvalid(ruleGroupName)) {
    errors = MESSAGES.RULE_GROUPS.NAME.MAX_LENGTH;
  }

  return errors;
};
